<header class="header-page">
  <h1 class="header__page__content__title">Boletos</h1>
</header>
<main class="main__content">
  <ng-template #naoPossuiBoletos>
    <section class="ngTemplateNaoPossui">
      <p>Você não Possui Boletos!</p>
    </section>
  </ng-template>
  <ng-template #showLoading>
    <spinner [show]="loading"></spinner>
  </ng-template>
  <section *ngIf="!loading; else showLoading">
    <section *ngIf="boletos && boletos.length > 0 else naoPossuiBoletos">
      <section class="content__header__table display-sm-none">
        <div class="col-sm-1">Data de Emissão</div>
        <div class="col-sm-1">CPF</div>
        <div class="col-sm-3">Nome</div>
        <div class="col-sm-1 text-center">Valor</div>
        <div class="col-sm-1">Data de Vencimento</div>
        <div class="col-sm-4">Nome do Plano</div>
        <div class="col-sm-1 text-center">Ações</div>
      </section>
      <section class="content__main__table">
        <div class="table__card" *ngFor="let item of boletos">
          <div class="col-sm-1"><span>{{ item.documento_data_emissao_br.replaceAll('-','/') }}</span></div>
          <div class="col-sm-1"><span>{{ item.pagador_inscricao }}</span></div>
          <div class="col-sm-3"><span>{{ item.pagador_nome }}</span></div>
          <div class="col-sm-1 text-center"><span>R$ {{item.documento_valor | number: "1.2-2":"pt-br"}}</span></div>
          <div class="col-sm-1"><span>{{ item.documento_data_vencimento_br.replaceAll('-','/') }}</span></div>
          <div class="col-sm-4"><span>{{ item.produto }}</span></div>
          <div class="col-sm-1 text-center"><a href="{{item.documento_link}}" target="_blank">Download</a></div>
        </div>
      </section>
    </section>
  </section>
</main>